const handleError = (e: Error): string => {
    return `${e.name} ${e.message}`
}

export default handleError
